/**
 * Path eligibility rule card per scope §6.6.3. Atlas Day 3a P1.
 *
 * Surface: "ISG considers N path × channel combinations active. P
 * fulfillment approaches × C marketplaces. Combinations gate which products
 * are calculable." Substrate-driven from fpc.is_active count ×
 * marketplaces.is_active count.
 *
 * Atlas Day 3a Phase 0 #11 refinement: engine-layer JOIN is fpc × marketplaces
 * (per calculate_profitability:L358-359); manufacturer_distributors lives at
 * gate-altitude judgment per scope §6.6.3 L4 not engine JOIN.
 *
 * Click handler navigates to inspect view per Atlas Day 2.5 P1 URL routing.
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Network } from 'lucide-react';
import type { PathEligibilitySubstrate } from '../../../lib/atlas/transformationRowSubstrate';

export interface PathEligibilityCardProps {
  substrate: PathEligibilitySubstrate;
}

export default function PathEligibilityCard({
  substrate,
}: PathEligibilityCardProps): JSX.Element {
  const navigate = useNavigate();
  const { activePathCount, activeMarketplaceCount, combinationCount } = substrate;
  return (
    <button
      type="button"
      data-sub-region-id="path-eligibility"
      onClick={() => navigate('/admin/engine-atlas/inspect/path-eligibility')}
      className="w-full text-left border border-border-subtle bg-surface-0 rounded-md p-3 hover:border-accent transition-colors cursor-pointer"
    >
      <div className="flex items-start gap-2">
        <Network size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-ink-bright">Path eligibility</h3>
          <p className="text-xs text-ink-secondary mt-1">
            ISG considers {combinationCount} path × channel{' '}
            {combinationCount === 1 ? 'combination' : 'combinations'} active. {activePathCount}{' '}
            fulfillment {activePathCount === 1 ? 'approach' : 'approaches'} ×{' '}
            {activeMarketplaceCount}{' '}
            {activeMarketplaceCount === 1 ? 'marketplace' : 'marketplaces'}. Combinations gate
            which products are calculable.
          </p>
        </div>
      </div>
    </button>
  );
}
